import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
    fetchCategoriesStart,
    fetchCategoriesSuccess,
    fetchCategoriesFailure,
    fetchCategoriesRequest
} from '../whatsappCategoriesSlice';
import { getCategoriesApi } from '../../api/apiLists/whatsappProfileApi';
import { callWithAuth } from '../sagaApiHelper';

const CACHE_DURATION = 24 * 60 * 60 * 1000;

function* handleFetchCategories() {
    try {
        const categoriesState = yield select(state => state.whatsappCategories);
        const currentTime = new Date().getTime();

        if (categoriesState.isCached && categoriesState.lastUpdated) {
            const timeSinceLastUpdate = currentTime - categoriesState.lastUpdated;
            
            if (timeSinceLastUpdate < CACHE_DURATION && categoriesState.categories.length > 0) {
                return;
            }
        }

        yield put(fetchCategoriesStart());

        const res = yield call(callWithAuth, getCategoriesApi);

        if (res.status && Array.isArray(res.data) && res.data.length > 0) {
            yield put(fetchCategoriesSuccess(res.data));
        } else {
            yield put(fetchCategoriesFailure(res.errMsg || 'Failed to load categories'));
        }
    } catch (error) {
        const errorMessage = error.message || 'An error occurred while loading categories';
        yield put(fetchCategoriesFailure(errorMessage));
    }
}

export default function* whatsappCategoriesSaga() {
    yield takeLatest(fetchCategoriesRequest.type, handleFetchCategories);
}
